import type { ForecastProvider, WeekMatrix, ForecastRole } from './types';
import { genWeek, JOB_BASE_COLORS } from '../components/Campaign/CoverageHeatmap';

export const PROCEDURAL_ROLES: ForecastRole[] = Object.entries(JOB_BASE_COLORS).map(
  ([name, color]) => ({ id: name, name, color }),
);

export const proceduralProvider: ForecastProvider = {
  getWeekMatrix(role, weekOffset, withCampaign, overlayForRole): WeekMatrix {
    return genWeek(role, weekOffset, withCampaign, overlayForRole);
  },
  isLive(_weekOffset: number): boolean {
    return false;
  },
};
